module.exports = __webpack_public_path__ + "static/media/uk.eff5c16d.webp";